import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";

import "./button.scss";

function Button({
  label,
  iconClassName,
  image,
  customClassName,
  onClick,
  disabled,
  viewType,
  type,
  children,
}) {
  const buttonClasses = classNames({
    mainButton: viewType === "mainBtn",
    asLink: viewType === "noBorder",
    asLinkBig: viewType === "noBorderBig",
    transparentIcon: viewType === "transparentIcon",
    backButton: viewType === "backButton",
    clildrenBtn: viewType === "clildrenBtn",
    cancelBtn: viewType === "cancelBtn",
    removeBtn: viewType === "removeBtn",
    restrictButton: viewType === "restrictButton",
    [customClassName]: customClassName,
    [iconClassName]: iconClassName,
  });

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses}>
      {image && <img src={image} alt={label} />}
      {label}
      {children && children}
    </button>
  );
}

Button.propTypes = {
  viewType: PropTypes.oneOf([
    "mainBtn",
    "noBorder",
    "noBorderBig",
    "transparentIcon",
    "backButton",
    "clildrenBtn",
    "cancelBtn",
    "removeBtn",
    "restrictButton",
  ]),
  label: PropTypes.string,
  image: PropTypes.string,
  iconClassName: PropTypes.string,
  customClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  children: PropTypes.object,
};

Button.defaultProps = {
  label: "",
  image: "",
  iconClassName: "",
  customClassName: "",
  disabled: false,
  type: "",
  children: null,
  onClick: () => {},
};

export default Button;
